export default __webpack_public_path__ + "static/media/lab-conference.938b4c1e.svg";